/**
 * Vuex State for Notification Management
 * Manages notification state, loading states, pagination, and user interface controls
 */
export default {
  /**
   * @type {Array} notifications
   * @description Array of notification objects currently loaded in the application
   * @structure
   * [
   *   {
   *     id: string,
   *     title: string,
   *     message: string,
   *     type: string,
   *     priority: string,
   *     read: boolean,
   *     timestamp: Date,
   *     sender: Object,
   *     action: Object,
   *     metadata: Object
   *   }
   * ]
   */
  notifications: [],

  /**
   * @type {number} unreadCount
   * @description Total count of unread notifications for the current user
   * Used for badge counters and UI indicators
   */
  unreadCount: 0,

  /**
   * @type {boolean} loading
   * @description Indicates if initial notifications are being loaded
   * Controls main loading spinner and skeleton screens
   */
  loading: false,

  /**
   * @type {boolean} loadingMore
   * @description Indicates if additional notifications are being loaded (pagination)
   * Controls "load more" spinner and infinite scroll indicators
   */
  loadingMore: false,

  /**
   * @type {boolean} markingAllAsRead
   * @description Indicates if "mark all as read" operation is in progress
   * Controls button loading state and prevents duplicate operations
   */
  markingAllAsRead: false,

  /**
   * @type {boolean} hasMore
   * @description Indicates if there are more notifications available to load
   * Determines whether to show "load more" button or infinite scroll trigger
   */
  hasMore: false,

  /**
   * @type {number} currentPage
   * @description Current page number for pagination
   * Tracks the current position in the notification list for pagination
   */
  currentPage: 1,

  /**
   * @type {string} filter
   * @description Current filter applied to notifications
   * @enum ['all', 'unread']
   * Controls which notifications are displayed in the list
   */
  filter: "all",

  /**
   * @type {number} limit
   * @description Number of notifications to load per page
   * Configurable items per page for pagination
   */
  limit: 10,
};
